var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBarchatIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: "100%"
    },
    viewBox: "0 0 160 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 38.2189C0 36.257 1.59045 34.6665 3.55238 34.6665V34.6665C5.51431 34.6665 7.10476 36.257 7.10476 38.2189V64.9998H0V38.2189Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6571 33.8859C10.6571 31.924 12.2476 30.3335 14.2095 30.3335V30.3335C16.1714 30.3335 17.7619 31.924 17.7619 33.8859V65.0001H10.6571V33.8859Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3651 16.5524C47.3651 14.5905 48.9556 13 50.9175 13V13C52.8794 13 54.4699 14.5905 54.4699 16.5524V64.9999H47.3651V16.5524Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0222 12.2189C58.0222 10.257 59.6127 8.6665 61.5746 8.6665V8.6665C63.5365 8.6665 65.127 10.257 65.127 12.2189V64.9998H58.0222V12.2189Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7302 7.88588C94.7302 5.92395 96.3207 4.3335 98.2826 4.3335V4.3335C100.245 4.3335 101.835 5.92395 101.835 7.88588V65.0001H94.7302V7.88588Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.387 3.55238C105.387 1.59045 106.978 0 108.94 0V0C110.902 0 112.492 1.59045 112.492 3.55238V64.9999H105.387V3.55238Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M142.095 29.5524C142.095 27.5904 143.686 26 145.648 26V26C147.61 26 149.2 27.5905 149.2 29.5524V64.9999H142.095V29.5524Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M152.752 25.2189C152.752 23.257 154.343 21.6665 156.305 21.6665V21.6665C158.267 21.6665 159.857 23.257 159.857 25.2189V64.9998H152.752V25.2189Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarchatIllustration);
export default __webpack_public_path__ + "static/media/barchat_illustration.8582b5a1d1c7bd8b24efb9a5fa1ad071.svg";
export { ForwardRef as ReactComponent };